import type { Goal } from '@/lib/engagement.core';

/****************
 * Where a user is in Get Started (pages/GetStarted.tsx), kept across the
 * Builder and Copy Trade so each can show the step bar and send them on.
 * This browser only: it is a convenience, the session itself is the record.
 ****************/
export const GS_KEY = 'copyfi.getStarted';
export const GS_SEEN_KEY = (userId: string) => `copyfi.getStarted.seen:${userId}`;

export interface GetStartedState {
  goal: Goal;
  traderUid?: string;
  traderName?: string;
  step: number;
  /** The guided first visit (2026-10-22): the strategy saved, the amount the
   *  person typed, and the backtest started with them. */
  strategyName?: string;
  amount?: number;
  backtestId?: number;
}

export function readGetStarted(): GetStartedState | null {
  try {
    const v = localStorage.getItem(GS_KEY);
    return v ? (JSON.parse(v) as GetStartedState) : null;
  } catch {
    return null;
  }
}

export function writeGetStarted(s: GetStartedState | null): void {
  try {
    if (s) localStorage.setItem(GS_KEY, JSON.stringify(s));
    else localStorage.removeItem(GS_KEY);
  } catch {
    /* private mode: the flow still works, without the step bar */
  }
}
